export const handleLimitCharacter = (
  text: string | undefined,
  limit: number
) => {
  if (!text) return "";
  const resultWithDot = `${text.substring(0, limit).trim()}...`;
  const res = text.length > limit ? resultWithDot : text;
  return res;
};
